/*
 * Better Turns POS System
 * Copyright (c) 2024 Better Turns LLC
 * All rights reserved.
 *
 * Author: Gabe Mohacsi
 * Description: About Section.
 * License: Proprietary - Redistribution, modification, or use without
 * explicit permission from Better Turns LLC is prohibited.
 */
// client/src/components/sections/AboutSection.js

import React from 'react';

const AboutSection = () => {
  return (
    <section
      id="about"
      className="bg-white py-16 px-6 md:px-20 text-center"
    >
      <div className="max-w-5xl mx-auto">
        <h3 className="text-3xl md:text-4xl font-extrabold text-primary mb-8">
          What Makes BetterTurns Different?
        </h3>

        <p className="text-lg md:text-xl text-gray-800 leading-relaxed mb-10 max-w-3xl mx-auto">
          BetterTurns is more than a toolset—it's a shared movement for small
          businesses to win together. Our platform combines{' '}
          <strong className="text-primary font-semibold">
            co-operative buying power
          </strong>
          ,{' '}
          <strong className="text-primary font-semibold">
            shared analytics
          </strong>
          , and{' '}
          <strong className="text-primary font-semibold">
            cloud-based merchandising tools
          </strong>{' '}
          once only available to national chains.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
          <div className="bg-soft-earth rounded-lg p-6 shadow-md">
            <h4 className="text-xl font-semibold text-primary mb-2">
              📊 Shared Analytics
            </h4>
            <p className="text-gray-700">
              Use real sales data across the co-op to guide your decisions—not
              guesswork.
            </p>
          </div>

          <div className="bg-soft-earth rounded-lg p-6 shadow-md">
            <h4 className="text-xl font-semibold text-primary mb-2">
              🤝 Co-op Powered Tools
            </h4>
            <p className="text-gray-700">
              Merchandising tools built to support collaboration, not isolation.
            </p>
          </div>

          <div className="bg-soft-earth rounded-lg p-6 shadow-md">
            <h4 className="text-xl font-semibold text-primary mb-2">
              🛠️ Enterprise-Level Tech
            </h4>
            <p className="text-gray-700">
              Cloud-native ERP + POS without the price tag or complexity of
              corporate systems.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
